/**
 * Created by ferto
 * Marciano Digital Agency
 * www.marciano.com.mx
 * Date: 01/02/2018.
 *
 * index Vue Store
 */
import BaseStore from '@/store/base-store'
const options = {}
export default new BaseStore('assignments', options)



// WEBPACK FOOTER //
// ./src/store/assignments/index.js